import { SET_SELECTED } from 'reduxes/slices/selected/actions'

const initialState = {
  topicId: null,
  directChat: null,
  timelineId: null,
  widgetQuestionId: 'root',
  productURL: null,
}

export function selected(state = initialState, action) {
  switch (action.type) {
    case SET_SELECTED:
      return {
        ...state,
        ...action.state,
      }
    default:
      return state
  }
}
